import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import CookieConsent from './components/organisms/CookieConsent'
import {initializeAnalytics} from './lib/analytics'
initializeAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <CookieConsent />
  </StrictMode>,
)
